import { Button } from "@mui/material";
import React from "react";

const FilledButton = ({
  btnname,
  onClick,
  icon = null,
  color = "#34A853",
  width,
}) => {
  return (
    <Button
      variant="contained"
      sx={{
        bgcolor: color,
        borderRadius: "20px",
        py: 0.5,
        px: 1.5,
        textTransform: "none",
        "&:hover": { backgroundColor: color },
        fontSize: "0.82rem",
        height: "32px",
        width: width || "170px",
      }}
      onClick={onClick}
    >
      {icon && React.cloneElement(icon)}
      {btnname}
    </Button>
  );
};

export default FilledButton;
